import { Environment } from 'src/app/types';

export const environment: Environment = {
  production: true,
  apiUrl: 'https://api2.staging.machineric.com/client-web',
  apiPrivate: 'https://api2.staging.machineric.com/client-web-marketplace',
  awsCognitoEndpoint: 'https://cognito-idp.eu-central-1.amazonaws.com',
  awsCognitoPool: 'eu-central-1_NqGJqKAOq',
  awsCognitoClient: '3lsnf7bjeumr2t3frdif5norij',
};
